import React from 'react'
import { makeStyles, createStyles, theme } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    main: {
      backgroundColor: '#f1f1f1',
      padding: '20px',
      float: 'left',
      textAlign: 'left',
      fontSize: '16px',
      fontFamily: 'Times New Roman',
      color: 'black',
      //   width: "60%",
    },
    heading: {
      textAlign: 'center',
      fontFamily: 'Times New Roman',
      fontWeight: 'bold',
      color: 'black',
    },
    text: { fontSize: '16px', fontFamily: 'Times New Roman', color: 'black' },
  }),
)

const ChildSafetyRigDisclaimer = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} md={2} lg={3}>
            {/* <Paper className={classes.paper}>xs=3</Paper> */}
          </Grid>
          <Grid item xs={10} sm={8} md={8} lg={6}>
            <Paper className={classes.main}>
              <h1 className={classes.heading} style={{ fontSize: 33 }}>
                <b>Child Safety Standards – RigV App</b>
              </h1>
              {/* <h2 className={classes.heading} style={{ fontSize: '23px' }}> */}
                {/* <b> "Green RigV Child Safety" – RigV App </b> */}
                {/* <br/>
                <b>Last updated: January 2026</b> */}
              {/* </h2>
              <Typography className={classes.text}>
                Read the following terms and conditions carefully before
                downloading,installing or using this software (defined below).
                Filling in the space next to "I accept the terms in the License
                Agreement" indicates your acceptance of these terms and
                conditions. If you do not agree with such terms and
                conditions,click "Cancel".This Software is available only to
                individuals aged 13 years or older.if you are 13 or older but
                under the age of 18,you should review these terms and conditions
                with your parent or guardian to make sure that you and your
                parent or guardian understand these terms and conditions.
              </Typography> */}
              <br />
              {/* <h2 className={classes.heading} style={{ fontSize: '23px' }}>
                LICENSE
              </h2> */}
              {/* <Typography className={classes.text}>
                This End User License Agreement("License" or "License
                Agreement") is a legal agreement between Dolphin Logic System
                Private Limited("Dolphin") and you and applies to your use of
                this RigV software and all related documentation that
                accompanies this application("Software").
              </Typography> */}
              {/* <br />
              <Typography className={classes.text}>
                Dolphin's licensors refers to any third parties licensing all or
                any portion such Software to Dolphin.This License is
                specifically intended for the benefit of Dolphin and any Dolphin
                licensors.
              </Typography>
              <br /> */}
              <ol>
                <li>
             About RigV
             <br/>
                    RigV is a vehicle tracking and monitoring application developed by Dolphin Logic Systems Private Limited.
                    The app is designed to help users monitor vehicle location, movement, and related telemetry data for purposes such as fleet management, employee transport, school transportation, and personal vehicle tracking.
                    RigV does not provide social networking, dating, messaging between unknown users, or content sharing features.
                </li>
                <br />
                <li>
                 Commitment to Child Safety
             <br/>

Dolphin Logic Systems Private Limited is committed to maintaining a safe digital environment and strictly opposes child sexual abuse, exploitation, and inappropriate content in any form.
We maintain zero tolerance for:
Child sexual abuse material (CSAM)
Sexual exploitation of minors
Grooming or inappropriate interaction involving children
Any content or behavior that violates child safety laws
                </li>
                <br />
                <li>
                 App Usage & Child-Related Data
             <br/>

RigV:
<br/>

Does not allow public user-generated content
Does not include chat, dating, or social interaction features
Does not promote interaction between minors and unknown users
In use cases involving school buses or vehicles transporting minors:
Data is accessed only by authorized administrators or guardians
Location data is used strictly for safety, monitoring, and operational purposes
No child personal data is shared publicly or used for advertising

                </li>
                <br />
                <li>
                Prohibited Content & Behavior
             <br/>

The following are strictly prohibited within the RigV platform:
Uploading or sharing any sexual, abusive, or exploitative content involving minors
Using the platform for harassment, abuse, or illegal monitoring
Misuse of location data in violation of privacy or safety laws
Any detected violation may result in:
Immediate suspension or termination of access
Reporting to appropriate legal authorities, where required by law
                </li>
                <br />
                <li>
                 Reporting Child Safety Concerns
             <br/>

If any user, parent, guardian, or authority becomes aware of:
Suspicious activity
Misuse of the app involving minors
Any content or behavior that may put a child at risk
They are encouraged to report it immediately.
📩 Contact for Reporting:
Email: dolphindls.software@gmail.com 
Subject Line: RigV – Child Safety Concern
All reports are reviewed promptly and handled in accordance with applicable laws.
                </li>
                <br />
                <li>
             Legal Compliance
             <br/>

RigV complies with:
Google Play Developer Policies
Applicable local and national child protection laws
Data protection and privacy regulations
We cooperate fully with law enforcement agencies when legally required.
                </li>
                <br />
                <li>
                 Child Safety Contact Point
             <br/>

Google Play or legal authorities may contact us regarding child safety compliance at:
Company Name: Dolphin Logic Systems Private Limited
App Name: RigV
Designated Contact Email: support@rigv.in
</li>
                  <br />
                  <li>
                   Policy Updates
             <br/>

This Child Safety Standards document may be updated from time to time to remain compliant with:
Google Play policy changes
Legal and regulatory updates
Product feature changes
<br/>
✅ Important Notes for Play Store Review
This page satisfies “Published Child Safety Standards” requirement
It clearly references RigV and Dolphin Logic Systems Private Limited
It includes reporting mechanism + designated contact
It clarifies that RigV is not a social or dating app
                </li>
                {/* <br />
                <li>
                  Third Party Services and Websites. As part of your use of the
                  Software, you may be provided with the opportunity to access
                  Dolphin's and third party services and web sites (collectively
                  and individually,"Services"). Use of the Services may require
                  internet access and that you accept additional terms of use.
                  You acknowledge and agree that while Dolphin and or such third
                  parties may not currently have set a fixed upper limit on the
                  number of transmissions you may send or receive through the
                  Service or the amount of storage space used for the provision
                  of the service, such fixed upper limits may be set by Dolphin
                  and or such third parties at any time, at Dolphin and or such
                  third parties' sole discretion.
                </li>
                <br />
                <li>
                  Your Representation and Warranties. You represent and warrant
                  that you possess the legal right and ability to agree to this
                  License Agreement, and that all information or material that
                  you transmit through the Software is owned by you. is
                  true,accurate and current, including Login Credentials. You
                  agree that you will not: (i) transit any material that is
                  copyrighted,protected by trade secret or otherwise subjected
                  to third party proprietary rights, including privacy and
                  publicity rights, unless you are the owner of such rights or
                  have written permission from their rightful owner to post the
                  materials and to grant the right to use such materials as
                  provided in this Agreement, (ii)submit any false information
                  or misrepresentation that could result in liability or damage
                  to us or any third party; (iii) submit any material that is
                  unlawful,obscene,defamatory,libelous,
                  <br />
                  threatening,pornographic,graphic or gratuitously
                  violent,harassing,hateful,racially or ethnically
                  offensive,encourages conduct that would give rise to criminal
                  or civil liability,violate any law,or is otherwise
                  inappropriate; (iv) impersonate another person, including
                  submitting their photographs as your own; (v) transmit
                  worms,viruses or other malicious codes; and (vi) violate the
                  terms and conditions of any website or application to which
                  you transmit Images through the Software.
                  <br />
                  You affirm that you are over the age of 13, and acknowledge
                  that the Software is not available for children under 13. If
                  you are under 13 years of age, then you may not use the
                  Software.
                </li>
                <br />
                <li>
                  DISCLAIMER OF WARRANTY. The Software is provided to you "AS
                  IS" Dolphin and its licensors do not warrant that the
                  functions contained in the Software will meet your
                  requirements or that the operation of the Software will be
                  uninterrupted or error free. You assume responsibility for
                  operation of the Software, and for the installation, use, and
                  results obtained from the Software.
                  <br />
                  The Software may contain hypertext links to third-party web
                  sites or information. Dolphin does not make any warranty,
                  endorsement, sponsorship, or recommendation of the
                  third-party, the third-party web site, or the information
                  contained therein. Dolphin is not responsible for the
                  availability of any such web site or liable for the content
                  thereon. You need to make your own decisions regarding your
                  interactions or communications with any other web site.
                  <br />
                  Subject to any applicable legislation which prohibits the
                  following exclusions, DOLPHIN AND ITS LICENSORS MAKE NO
                  WARRANTIES OF ANY KIND RELATED TO THE SOFTWARE, EITHER EXPRESS
                  OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF
                  MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE,
                  NON-INFRINGEMENT, or arising from course of performance,
                  dealing, usage or trade. Some states and countries do not
                  allow the exclusion of implied warranties, or have legislation
                  that imposes certain statutory warranties that cannot be
                  excluded, so the above exclusion may not apply to you.
                </li>
                <br />
                <li>
                  LIMITATION OF LIABILITY. Your use of the Software is entirely
                  at your own risk. Under no circumstance will Dolphin, its
                  agents, licensors or suppliers be liable to you on account of
                  your use or misuse of, or reliance on, the Software. TO THE
                  EXTENT PERMITTED BY LAW, IN NO EVENT WILL DOLPHIN, ITS
                  LICENSORS, SUPPLIERS OR DEALERS BE LIABLE TO YOU FOR ANY
                  ACTUAL, DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
                  OR PUNITIVE DAMAGES, INCLUDING ANY LOST PROFITS, LOST SAVINGS,
                  costs of procurement of substitute products or services OR
                  OTHER DAMAGES ARISING OUT OF THE USE OR INABILITY TO USE THE
                  SOFTWARE EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                  Some states and countries do not allow the limitation or
                  exclusion of liability for incidental or consequential
                  damages, or have legislation that restricts the limitation or
                  exclusion of liability, so the above limitation may not apply
                  to you.
                </li>
                <br />
                <li>
                  The Software includes certain Application Programming
                  Interfaces ("API's") that are part of the IOS software
                  platform and are governed by the terms and conditions of the
                  open source license, Apache 2.0 which can be found at
                  http://www.apache.org/licenses/LICENSE-2.0.html.
                </li>
                <br />
                <li>
                  Miscellaneous. Each provision of this License Agreement is
                  severable. If a provision is found to be unenforceable, this
                  finding does not affect the enforceability of the remaining
                  provisions, terms, or conditions of this License Agreement.
                  This License Agreement is binding on successors and assigns.
                  Dolphin will not be responsible for any non-performance or
                  delay attributable in whole or in part to any cause beyond its
                  reasonable control. Nothing contained herein shall be
                  construed as creating any agency, partnership, or other form
                  of joint enterprise between the parties. You acknowledge that
                  you have read this License Agreement, that you understand it,
                  that you agree to be bound by its terms, and that the
                  foregoing is the complete and exclusive statement of the
                  License Agreement.
                </li> */}
              </ol>
            </Paper>
          </Grid>
          <Grid item xs={1} sm={2} md={2} lg={3}>
            {/* <Paper className={classes.paper}>xs=3</Paper> */}
          </Grid>
        </Grid>
      </div>
    </>
  )
}
export default ChildSafetyRigDisclaimer
